// extracted by mini-css-extract-plugin
export default {"body":"App__body___Ou0ms","main":"App__main___eMqSv","footer":"App__footer___Pg6MC"};